import { Button, Layout, Tag } from '@loadsmart/miranda-react'

import { formatDate, formatDescriptionWithZip } from 'core/presenters/stopPresenter'
import { Icon } from 'core/ui/components/icon/Icon'
import { ShipperInformation } from 'core/ui/components/shipper/ShipperInformation'
import { LaneInformation } from 'core/ui/components/stop/LaneInformation'

import { formatBidButtonLabel } from '../presenter/spotQuotePresenter'
import { SpotQuoteBidDeadline } from './SpotQuoteBidDeadline'
import { type SpotQuoteCardProps } from './SpotQuoteCard'
import { StyledVerticalDivider } from './SpotQuoteCard.styles'

export function SingleSpotQuoteDesktopCard({
  expiredQuote,
  item,
  showDeadline,
  showShipper,
  onBidClick,
}: SpotQuoteCardProps) {
  const { lanes, shipper, isUnderNegotiation } = item
  // for single spot quotes, the rates array will always contain a single SpotQuoteListRate
  const [{ quote }] = lanes.rates

  return (
    <Layout.Box
      backgroundColor="color-background-primary"
      borderColor="color-border"
      borderWidth="border-thin"
    >
      <Layout.Group align="center" justify="space-between">
        <Layout.Stack>
          <LaneInformation
            stops={quote.stops}
            distance={quote.mileage}
            valueFormatter={formatDescriptionWithZip}
            extraFormatter={stop =>
              formatDate(stop, {
                format: 'MM/dd/yyyy',
                fallback: 'Pending appointment',
              })
            }
            distanceUnit="miles"
          />
          <Layout.Group align="center">
            {showShipper && (
              <ShipperInformation
                companyName={shipper.companyName}
                contactName={shipper.name}
                email={shipper.email}
                logo={shipper.logoUrl}
                phone={shipper.phoneNumber}
              />
            )}
            {showDeadline && (
              <>
                <StyledVerticalDivider />
                <SpotQuoteBidDeadline
                  deadline={quote.bidsDeadline}
                  isExpired={expiredQuote}
                  isMultiline
                />
              </>
            )}
          </Layout.Group>
        </Layout.Stack>
        <Layout.Stack align="flex-end" style={{ marginTop: isUnderNegotiation ? 'unset' : 'auto' }}>
          {isUnderNegotiation && (
            <Tag variant="warning" leading={<Icon name="attention" />}>
              Counter-offer received
            </Tag>
          )}
          <Button type="button" variant="secondary" onClick={onBidClick}>
            {formatBidButtonLabel({ isUnderNegotiation })}
          </Button>
        </Layout.Stack>
      </Layout.Group>
    </Layout.Box>
  )
}
